import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Loader from './components/Loader';
import reportWebVitals from './reportWebVitals';
import 'flowbite';
import { Provider } from 'react-redux';
import { createStore } from 'redux';
import reducers from './redux/reducers';
import { createNewHeaders, updateHeaders } from './functions/Kubuku';
import { KONFIGURASI } from './api';

const store = createStore(reducers);

// --- Komponen Root Utama ---
function RootApp() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let domainName = window.location.hostname;
    // domainName = "tokobukusagungseto.com";
    // domainName = "tokobukupintar.com";
    // domainName = "tokobukuinfolib.com";
    // domainName = "artibumiintarandigital.com";
    // domainName = "metamorfosabook.com";

    const flagOpen = localStorage.getItem('flagOpen');
    if (flagOpen !== '1') {
      createNewHeaders('', '');
    } else {
      updateHeaders('', '');
    }

    function hexToRgb(hex) {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? {
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
          }
        : null;
    }

    const postData = {
      method: 'get',
      headers: window.customHeaders,
    };

    // Fetch konfigurasi API
    fetch(`${KONFIGURASI}/${domainName}`, postData)
      .then((res) => res.json())
      .then((json) => {
        console.log('konfig =', json);
        if (json.code === 200) {
          const warna = hexToRgb(json.data.color_primary);

          // Simpan ke localStorage
          localStorage.setItem('namaToko', json.data.nama);
          localStorage.setItem('domain', json.data.domain);
          localStorage.setItem('logo', json.data.logo);
          localStorage.setItem('logo_putih', json.data.logo_putih);
          localStorage.setItem('kodeApp', json.data.kode);
          localStorage.setItem('alamat', json.data.alamat);
          localStorage.setItem('email', json.data.email);
          localStorage.setItem('footer', json.data.keterangan_footer);
          localStorage.setItem('poster', json.data.poster_favorite);
          localStorage.setItem('nomorTelepon', json.data.no_ponsel);
          localStorage.setItem('promoGabungan', json.data.promo_gabungan);
          localStorage.setItem(
            'colorPrimary',
            `${warna.r} ${warna.g} ${warna.b}`
          );
          localStorage.setItem('payLogo', json.data.pay_logo);
          localStorage.setItem('icon', json.data.icon);

          createNewHeaders('', '');
          document.title = json.data.nama;

          // Setelah konfigurasi berhasil didapat → hentikan loading
          setIsLoading(false);
        } else {
          console.error('Gagal mengambil konfigurasi:', json.message);
        }
      })
      .catch((err) => {
        console.error('Error fetch konfigurasi:', err);
      });
  }, []);

  // Saat loading, tampilkan komponen Loader
  if (isLoading) {
    return <Loader />;
  }

  // Setelah data didapat, render aplikasi utama
  return <App />;
}

// --- Render React ---
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RootApp />
    </Provider>
  </React.StrictMode>
);

reportWebVitals();
